import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../reducers";
import {getSession} from "../../../../services/Session/reducer";
import {useTranslation, withTranslation} from "react-i18next";
import React, {useState} from "react";
import {ReactComponent as CalendarIco} from "../../../../../images/icons/calendar.svg";
import ChangePickDateDrawer from "../../../../components/Drawer/ChangePickDateDrawer";

interface OwnProps {
    menu: any;
    preview: boolean;
    higherDrawerZIndex?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const MenuAvailabilityDateButton = ({menu, session, higherDrawerZIndex}: Props) => {
    const {t} = useTranslation();
    const [showPickDateDrawer, setShowPickDateDrawer] = useState(false);

    return (
        <div className='mt-2'>
            <button type="button" className="btn btn-default" onClick={() => setShowPickDateDrawer(true)}>
                {t("modules.menu.action.change_pickup_date.title")}
                <CalendarIco className="ms-1"/>
            </button>
            <ChangePickDateDrawer menuId={menu.id} pickDate={session.pickup_at}
                                  showDrawer={showPickDateDrawer}
                                 onHide={() => setShowPickDateDrawer(false)} higherZIndex={higherDrawerZIndex}/>
    </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuAvailabilityDateButton));